import { render, staticRenderFns } from "./BasicEnergyConsumption.vue?vue&type=template&id=71efbd5a&scoped=true"
import script from "./BasicEnergyConsumption.vue?vue&type=script&lang=js"
export * from "./BasicEnergyConsumption.vue?vue&type=script&lang=js"
import style0 from "./BasicEnergyConsumption.vue?vue&type=style&index=0&id=71efbd5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71efbd5a",
  null
  
)

export default component.exports